// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Reset ─────────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ─── Page Shell ─────────────────────────────────────────── */
.auth-page {
  height: 100vh;                      /* fixed, not min-height */
  overflow-y: auto;                   /* scroll happens HERE */
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;  /* smooth iOS scroll */

  display: flex;
  align-items: flex-start;            /* don't center — let it flow from top */
  justify-content: center;

  padding: 32px 16px 60px;           /* generous bottom padding */
  font-family: 'Inter', -apple-system, sans-serif;
  position: relative;

  background:
    radial-gradient(ellipse at 50% -10%, #c9e8f8 0%, transparent 60%),
    linear-gradient(180deg, #b8d9f0 0%, #d6eaf8 30%, #e8f4fb 60%, #f0f8fc 80%, #e0eef8 100%);

  /* Fix the background so it doesn't scroll with content */
  background-attachment: fixed;
}



/* Keep decorative rings from causing overflow */
.auth-page::before {
  content: '';
  position: fixed;                   /* fixed instead of absolute */
  width: 700px;
  height: 700px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.45);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 0;
}

.auth-page::after {
  content: '';
  position: fixed;                   /* fixed instead of absolute */
  width: 520px;
  height: 520px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 0;
}

/* Cloud blobs — fix them too so they don't add scroll height */
.auth-cloud {
  position: fixed;                   /* fixed instead of absolute */
  border-radius: 50%;
  background: rgba(255,255,255,0.55);
  filter: blur(32px);
  pointer-events: none;
  z-index: 0;
}

.auth-cloud-1 { width: 380px; height: 160px; bottom: 60px; left: -60px; }
.auth-cloud-2 { width: 300px; height: 130px; bottom: 20px; right: -40px; }
.auth-cloud-3 { width: 200px; height: 90px;  bottom: 120px; left: 30%; }

/* ─── Card ───────────────────────────────────────────────── */
.auth-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 500px;
  background: rgba(255,255,255,0.72);
  backdrop-filter: blur(24px) saturate(1.4);
  -webkit-backdrop-filter: blur(24px) saturate(1.4);
  border: 1px solid rgba(255,255,255,0.9);
  border-radius: 28px;
  padding: 40px 36px 36px;
  box-shadow:
    0 4px 6px rgba(0,0,0,0.03),
    0 12px 40px rgba(100,160,210,0.12),
    0 1px 0 rgba(255,255,255,0.8) inset;
}

/* ─── Card Top Icon ──────────────────────────────────────── */
.auth-icon-wrap {
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(0,0,0,0.07);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 22px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
}

.auth-icon-wrap svg {
  width: 26px;
  height: 26px;
  stroke: #1a1a1a;
  fill: none;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Success icon variant */
.auth-icon-wrap.success { background: #f0fdf4; border-color: rgba(34,197,94,0.2); }
.auth-icon-wrap.success svg { stroke: #16a34a; }

/* ─── Typography ─────────────────────────────────────────── */
.auth-title {
  font-size: 18px;
  font-weight: 700;
  color:#217559;
  text-align: center;
  line-height: 1.25;
  margin-bottom: 8px;
  letter-spacing: -0.4px;
}

.auth-subtitle {
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  line-height: 1.55;
  margin-bottom: 28px;
  font-weight: 400;
}

/* ─── Form ───────────────────────────────────────────────── */
.auth-form { display: flex; flex-direction: column; gap: 10px; }

/* Override Ant Design completely */
.auth-form .ant-form-item { margin-bottom: 0; }
.auth-form .ant-form-item-explain-error {
  font-size: 11.5px;
  font-family: 'Inter', sans-serif;
  margin-top: 3px;
  padding-left: 2px;
}

.auth-input-wrap { position: relative; }

.auth-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  stroke: #9ca3af;
  fill: none;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: none;
  z-index: 2;
  transition: stroke 0.18s;
}

.auth-input-wrap:focus-within .auth-input-icon { stroke: #374151; }

/* Ant Input override */
.auth-input-wrap .ant-input,
.auth-input-wrap .ant-input-affix-wrapper,
.auth-input-wrap .ant-input-password {
  height: 46px !important;
  border-radius: 12px !important;
  border: 1.5px solid rgba(0,0,0,0.09) !important;
  background: rgba(248,249,250,0.85) !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 14px !important;
  color: #111827 !important;
  padding-left: 42px !important;
  box-shadow: none !important;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s !important;
}

.auth-input-wrap .ant-input-affix-wrapper {
  padding-left: 42px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: center !important;
}

.auth-input-wrap .ant-input-affix-wrapper .ant-input {
  padding-left: 0 !important;
  height: auto !important;
  border: none !important;
  background: transparent !important;
}

.auth-input-wrap .ant-input-prefix { display: none !important; }

.auth-input-wrap .ant-input:focus,
.auth-input-wrap .ant-input-affix-wrapper:focus,
.auth-input-wrap .ant-input-affix-wrapper-focused {
  border-color: rgba(0,0,0,0.25) !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(0,0,0,0.05) !important;
}

.auth-input-wrap .ant-input::placeholder { color: #9ca3af !important; }
.auth-input-wrap .ant-input[disabled] {
  background: rgba(243,244,246,0.9) !important;
  color: #9ca3af !important;
  border-color: rgba(0,0,0,0.06) !important;
}

.auth-input-wrap .ant-input-password-icon,
.auth-input-wrap .ant-input-suffix svg { color: #9ca3af !important; font-size: 14px !important; }

/* ─── Primary Button ─────────────────────────────────────── */
.auth-btn {
  width: 100% !important;
  height: 50px !important;
  background: #217559 !important;
  border: none !important;
  border-radius: 14px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #fff !important;
  letter-spacing: -0.1px !important;
  cursor: pointer !important;
  transition: background 0.18s, transform 0.12s, box-shadow 0.18s !important;
  box-shadow: 0 2px 12px rgba(0,0,0,0.18) !important;
  margin-top: 4px !important;
}

.auth-btn:hover {
  background: #1f2937 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 18px rgba(0,0,0,0.22) !important;
}

.auth-btn:active { transform: translateY(0) !important; }

/* ─── Forgot / inline link ───────────────────────────────── */
.auth-forgot {
  text-align: right;
  margin-top: -2px;
}

.auth-forgot a,
.auth-link {
  font-size: 13px;
  color:#217559;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.18s;
}

.auth-forgot a:hover,
.auth-link:hover { color: #111827; text-decoration: underline; }

/* ─── Divider ────────────────────────────────────────────── */
.auth-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px 0 14px;
}

.auth-divider-line {
  flex: 1 1;
  height: 1px;
  /* dotted style like the screenshot */
  background: none;
  border-bottom: 1.5px dashed rgba(0,0,0,0.12);
}

.auth-divider-text {
  font-size: 12.5px;
  color: #9ca3af;
  white-space: nowrap;
  font-weight: 400;
}

/* ─── Social Buttons ─────────────────────────────────────── */
.auth-social-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.auth-social-btn {
  height: 46px;
  border-radius: 12px;
  border: 1.5px solid rgba(0,0,0,0.09);
  background: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s, transform 0.12s;
}

.auth-social-btn:hover {
  background: #fff;
  border-color: rgba(0,0,0,0.18);
  transform: translateY(-1px);
}

.auth-social-btn:active { transform: translateY(0); }

.auth-social-btn svg { width: 22px; height: 22px; }

/* ─── Footer Prompt ──────────────────────────────────────── */
.auth-prompt {
  text-align: center;
  font-size: 13.5px;
  color: #6b7280;
  margin-top: 20px;
}

.auth-prompt a {
  color: #217559;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.auth-prompt a:hover { text-decoration: underline; }

/* ─── Back link ──────────────────────────────────────────── */
.auth-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  margin-bottom: 20px;
  transition: color 0.18s;
  width: 100%;
}

.auth-back:hover { color: #111827; }
.auth-back svg { width: 15px; height: 15px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; }

/* ─── OTP boxes ──────────────────────────────────────────── */
.otp-row {
  display: flex;
  gap: 8px;
}

.otp-box {
  flex: 1 1;
  height: 52px;
  border: 1.5px solid rgba(0,0,0,0.09);
  border-radius: 12px;
  background: rgba(248,249,250,0.85);
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: #111827;
  outline: none;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;
  caret-color: #111827;
}

.otp-box:focus {
  border-color: rgba(0,0,0,0.25);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(0,0,0,0.05);
}

.otp-box.filled { background: #fff; border-color: rgba(0,0,0,0.18); }

/* ─── Password strength ──────────────────────────────────── */
.pw-strength-bar {
  height: 3px;
  background: rgba(0,0,0,0.08);
  border-radius: 99px;
  overflow: hidden;
  margin-top: 8px;
}

.pw-strength-fill {
  height: 100%;
  border-radius: 99px;
  transition: width 0.35s, background 0.35s;
}

.pw-hints {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 7px;
}

.pw-hint {
  font-size: 11px;
  padding: 3px 9px;
  border-radius: 99px;
  background: #217559;
  color: #9ca3af;
  font-weight: 500;
  transition: all 0.2s;
}

.pw-hint.pass { background: #f0fdf4; color: #16a34a; }

/* ─── Info note ──────────────────────────────────────────── */
.auth-note {
  background: rgba(240,249,255,0.8);
  border: 1px solid rgba(147,197,253,0.4);
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.auth-note svg {
  width: 15px;
  height: 15px;
  stroke: #3b82f6;
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  flex-shrink: 0;
  margin-top: 1px;
}

.auth-note p {
  font-size: 12.5px;
  color: #1d4ed8;
  line-height: 1.5;
  font-weight: 400;
  margin: 0;
}

/* ─── 2-col row ──────────────────────────────────────────── */
.auth-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

@media (max-width: 480px) {
  .auth-page {
    padding: 24px 14px 80px;         /* extra bottom so last element isn't cut off */
    align-items: flex-start;
  }

  .auth-card {
    padding: 28px 18px 24px;
    border-radius: 20px;
    width: 100%;
  }

  .auth-title {
    font-size: 22px;                 /* slightly smaller so it doesn't overflow */
  }

  .auth-social-row { grid-template-columns: repeat(3, 1fr); }
  .auth-row { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/auth.css"],"names":[],"mappings":"AAEA,8DAA8D;AAC9D,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE,+DAA+D;AAC/D;EACE,aAAa,uBAAuB,0BAA0B;EAC9D,gBAAgB,oBAAoB,wBAAwB;EAC5D,kBAAkB;EAClB,iCAAiC,GAAG,sBAAsB;;EAE1D,aAAa;EACb,uBAAuB,aAAa,wCAAwC;EAC5E,uBAAuB;;EAEvB,uBAAuB,YAAY,4BAA4B;EAC/D,+CAA+C;EAC/C,kBAAkB;;EAElB;;4FAE0F;;EAE1F,yDAAyD;EACzD,4BAA4B;AAC9B;;;;AAIA,gDAAgD;AAChD;EACE,WAAW;EACX,eAAe,oBAAoB,8BAA8B;EACjE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe,oBAAoB,8BAA8B;EACjE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE,eAAe,oBAAoB,8BAA8B;EACjE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,gBAAgB,YAAY,EAAE,aAAa,EAAE,YAAY,EAAE,WAAW,EAAE;AACxE,gBAAgB,YAAY,EAAE,aAAa,EAAE,YAAY,EAAE,YAAY,EAAE;AACzE,gBAAgB,YAAY,EAAE,YAAY,GAAG,aAAa,EAAE,SAAS,EAAE;;AAEvE,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,yCAAyC;EACzC,iDAAiD;EACjD,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB;;;uCAGqC;AACvC;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB,0BAA0B,mBAAmB,EAAE,iCAAiC,EAAE;AAClF,8BAA8B,eAAe,EAAE;;AAE/C,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE/D,mCAAmC;AACnC,4BAA4B,gBAAgB,EAAE;AAC9C;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB,kBAAkB,EAAE;;AAEvC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,wBAAwB;AAC1B;;AAEA,iDAAiD,eAAe,EAAE;;AAElE,uBAAuB;AACvB;;;EAGE,uBAAuB;EACvB,8BAA8B;EAC9B,+CAA+C;EAC/C,6CAA6C;EAC7C,2CAA2C;EAC3C,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,qCAAqC,wBAAwB,EAAE;;AAE/D;;;EAGE,yCAAyC;EACzC,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA,2CAA2C,yBAAyB,EAAE;AACtE;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;yCACyC,yBAAyB,EAAE,0BAA0B,EAAE;;AAEhG,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;EAC1B,0EAA0E;EAC1E,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,kDAAkD;AACpD;;AAEA,mBAAmB,mCAAmC,EAAE;;AAExD,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;mBACmB,cAAc,EAAE,0BAA0B,EAAE;;AAE/D,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,0BAA0B,wBAAwB,EAAE;;AAEpD,uBAAuB,WAAW,EAAE,YAAY,EAAE;;AAElD,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;AACA,uBAAuB,0BAA0B,EAAE;;AAEnD,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,mBAAmB,cAAc,EAAE;AACnC,iBAAiB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,UAAU,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAEtH,+DAA+D;AAC/D;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kEAAkE;EAClE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,kBAAkB,gBAAgB,EAAE,8BAA8B,EAAE;;AAEpE,+DAA+D;AAC/D;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD,+DAA+D;AAC/D;EACE,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB,UAAU,+CAA+C;IAChF,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe,kBAAkB,4CAA4C;EAC/E;;EAEA,mBAAmB,qCAAqC,EAAE;EAC1D,YAAY,0BAA0B,EAAE;AAC1C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* ─── Reset ─────────────────────────────────────────────── */\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n/* ─── Page Shell ─────────────────────────────────────────── */\n.auth-page {\n  height: 100vh;                      /* fixed, not min-height */\n  overflow-y: auto;                   /* scroll happens HERE */\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;  /* smooth iOS scroll */\n\n  display: flex;\n  align-items: flex-start;            /* don't center — let it flow from top */\n  justify-content: center;\n\n  padding: 32px 16px 60px;           /* generous bottom padding */\n  font-family: 'Inter', -apple-system, sans-serif;\n  position: relative;\n\n  background:\n    radial-gradient(ellipse at 50% -10%, #c9e8f8 0%, transparent 60%),\n    linear-gradient(180deg, #b8d9f0 0%, #d6eaf8 30%, #e8f4fb 60%, #f0f8fc 80%, #e0eef8 100%);\n\n  /* Fix the background so it doesn't scroll with content */\n  background-attachment: fixed;\n}\n\n\n\n/* Keep decorative rings from causing overflow */\n.auth-page::before {\n  content: '';\n  position: fixed;                   /* fixed instead of absolute */\n  width: 700px;\n  height: 700px;\n  border-radius: 50%;\n  border: 1px solid rgba(255,255,255,0.45);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.auth-page::after {\n  content: '';\n  position: fixed;                   /* fixed instead of absolute */\n  width: 520px;\n  height: 520px;\n  border-radius: 50%;\n  border: 1px solid rgba(255,255,255,0.3);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Cloud blobs — fix them too so they don't add scroll height */\n.auth-cloud {\n  position: fixed;                   /* fixed instead of absolute */\n  border-radius: 50%;\n  background: rgba(255,255,255,0.55);\n  filter: blur(32px);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.auth-cloud-1 { width: 380px; height: 160px; bottom: 60px; left: -60px; }\n.auth-cloud-2 { width: 300px; height: 130px; bottom: 20px; right: -40px; }\n.auth-cloud-3 { width: 200px; height: 90px;  bottom: 120px; left: 30%; }\n\n/* ─── Card ───────────────────────────────────────────────── */\n.auth-card {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  max-width: 500px;\n  background: rgba(255,255,255,0.72);\n  backdrop-filter: blur(24px) saturate(1.4);\n  -webkit-backdrop-filter: blur(24px) saturate(1.4);\n  border: 1px solid rgba(255,255,255,0.9);\n  border-radius: 28px;\n  padding: 40px 36px 36px;\n  box-shadow:\n    0 4px 6px rgba(0,0,0,0.03),\n    0 12px 40px rgba(100,160,210,0.12),\n    0 1px 0 rgba(255,255,255,0.8) inset;\n}\n\n/* ─── Card Top Icon ──────────────────────────────────────── */\n.auth-icon-wrap {\n  width: 60px;\n  height: 60px;\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid rgba(0,0,0,0.07);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 22px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.07);\n}\n\n.auth-icon-wrap svg {\n  width: 26px;\n  height: 26px;\n  stroke: #1a1a1a;\n  fill: none;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* Success icon variant */\n.auth-icon-wrap.success { background: #f0fdf4; border-color: rgba(34,197,94,0.2); }\n.auth-icon-wrap.success svg { stroke: #16a34a; }\n\n/* ─── Typography ─────────────────────────────────────────── */\n.auth-title {\n  font-size: 18px;\n  font-weight: 700;\n  color:#217559;\n  text-align: center;\n  line-height: 1.25;\n  margin-bottom: 8px;\n  letter-spacing: -0.4px;\n}\n\n.auth-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  text-align: center;\n  line-height: 1.55;\n  margin-bottom: 28px;\n  font-weight: 400;\n}\n\n/* ─── Form ───────────────────────────────────────────────── */\n.auth-form { display: flex; flex-direction: column; gap: 10px; }\n\n/* Override Ant Design completely */\n.auth-form .ant-form-item { margin-bottom: 0; }\n.auth-form .ant-form-item-explain-error {\n  font-size: 11.5px;\n  font-family: 'Inter', sans-serif;\n  margin-top: 3px;\n  padding-left: 2px;\n}\n\n.auth-input-wrap { position: relative; }\n\n.auth-input-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  stroke: #9ca3af;\n  fill: none;\n  stroke-width: 1.7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  pointer-events: none;\n  z-index: 2;\n  transition: stroke 0.18s;\n}\n\n.auth-input-wrap:focus-within .auth-input-icon { stroke: #374151; }\n\n/* Ant Input override */\n.auth-input-wrap .ant-input,\n.auth-input-wrap .ant-input-affix-wrapper,\n.auth-input-wrap .ant-input-password {\n  height: 46px !important;\n  border-radius: 12px !important;\n  border: 1.5px solid rgba(0,0,0,0.09) !important;\n  background: rgba(248,249,250,0.85) !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 14px !important;\n  color: #111827 !important;\n  padding-left: 42px !important;\n  box-shadow: none !important;\n  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s !important;\n}\n\n.auth-input-wrap .ant-input-affix-wrapper {\n  padding-left: 42px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  align-items: center !important;\n}\n\n.auth-input-wrap .ant-input-affix-wrapper .ant-input {\n  padding-left: 0 !important;\n  height: auto !important;\n  border: none !important;\n  background: transparent !important;\n}\n\n.auth-input-wrap .ant-input-prefix { display: none !important; }\n\n.auth-input-wrap .ant-input:focus,\n.auth-input-wrap .ant-input-affix-wrapper:focus,\n.auth-input-wrap .ant-input-affix-wrapper-focused {\n  border-color: rgba(0,0,0,0.25) !important;\n  background: #fff !important;\n  box-shadow: 0 0 0 3px rgba(0,0,0,0.05) !important;\n}\n\n.auth-input-wrap .ant-input::placeholder { color: #9ca3af !important; }\n.auth-input-wrap .ant-input[disabled] {\n  background: rgba(243,244,246,0.9) !important;\n  color: #9ca3af !important;\n  border-color: rgba(0,0,0,0.06) !important;\n}\n\n.auth-input-wrap .ant-input-password-icon,\n.auth-input-wrap .ant-input-suffix svg { color: #9ca3af !important; font-size: 14px !important; }\n\n/* ─── Primary Button ─────────────────────────────────────── */\n.auth-btn {\n  width: 100% !important;\n  height: 50px !important;\n  background: #217559 !important;\n  border: none !important;\n  border-radius: 14px !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  color: #fff !important;\n  letter-spacing: -0.1px !important;\n  cursor: pointer !important;\n  transition: background 0.18s, transform 0.12s, box-shadow 0.18s !important;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.18) !important;\n  margin-top: 4px !important;\n}\n\n.auth-btn:hover {\n  background: #1f2937 !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 18px rgba(0,0,0,0.22) !important;\n}\n\n.auth-btn:active { transform: translateY(0) !important; }\n\n/* ─── Forgot / inline link ───────────────────────────────── */\n.auth-forgot {\n  text-align: right;\n  margin-top: -2px;\n}\n\n.auth-forgot a,\n.auth-link {\n  font-size: 13px;\n  color:#217559;\n  text-decoration: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.18s;\n}\n\n.auth-forgot a:hover,\n.auth-link:hover { color: #111827; text-decoration: underline; }\n\n/* ─── Divider ────────────────────────────────────────────── */\n.auth-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 18px 0 14px;\n}\n\n.auth-divider-line {\n  flex: 1;\n  height: 1px;\n  /* dotted style like the screenshot */\n  background: none;\n  border-bottom: 1.5px dashed rgba(0,0,0,0.12);\n}\n\n.auth-divider-text {\n  font-size: 12.5px;\n  color: #9ca3af;\n  white-space: nowrap;\n  font-weight: 400;\n}\n\n/* ─── Social Buttons ─────────────────────────────────────── */\n.auth-social-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.auth-social-btn {\n  height: 46px;\n  border-radius: 12px;\n  border: 1.5px solid rgba(0,0,0,0.09);\n  background: rgba(255,255,255,0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.18s, border-color 0.18s, transform 0.12s;\n}\n\n.auth-social-btn:hover {\n  background: #fff;\n  border-color: rgba(0,0,0,0.18);\n  transform: translateY(-1px);\n}\n\n.auth-social-btn:active { transform: translateY(0); }\n\n.auth-social-btn svg { width: 22px; height: 22px; }\n\n/* ─── Footer Prompt ──────────────────────────────────────── */\n.auth-prompt {\n  text-align: center;\n  font-size: 13.5px;\n  color: #6b7280;\n  margin-top: 20px;\n}\n\n.auth-prompt a {\n  color: #217559;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n.auth-prompt a:hover { text-decoration: underline; }\n\n/* ─── Back link ──────────────────────────────────────────── */\n.auth-back {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  margin-bottom: 20px;\n  transition: color 0.18s;\n  width: 100%;\n}\n\n.auth-back:hover { color: #111827; }\n.auth-back svg { width: 15px; height: 15px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; }\n\n/* ─── OTP boxes ──────────────────────────────────────────── */\n.otp-row {\n  display: flex;\n  gap: 8px;\n}\n\n.otp-box {\n  flex: 1;\n  height: 52px;\n  border: 1.5px solid rgba(0,0,0,0.09);\n  border-radius: 12px;\n  background: rgba(248,249,250,0.85);\n  font-family: 'Inter', sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  text-align: center;\n  color: #111827;\n  outline: none;\n  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;\n  caret-color: #111827;\n}\n\n.otp-box:focus {\n  border-color: rgba(0,0,0,0.25);\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(0,0,0,0.05);\n}\n\n.otp-box.filled { background: #fff; border-color: rgba(0,0,0,0.18); }\n\n/* ─── Password strength ──────────────────────────────────── */\n.pw-strength-bar {\n  height: 3px;\n  background: rgba(0,0,0,0.08);\n  border-radius: 99px;\n  overflow: hidden;\n  margin-top: 8px;\n}\n\n.pw-strength-fill {\n  height: 100%;\n  border-radius: 99px;\n  transition: width 0.35s, background 0.35s;\n}\n\n.pw-hints {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 7px;\n}\n\n.pw-hint {\n  font-size: 11px;\n  padding: 3px 9px;\n  border-radius: 99px;\n  background: #217559;\n  color: #9ca3af;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.pw-hint.pass { background: #f0fdf4; color: #16a34a; }\n\n/* ─── Info note ──────────────────────────────────────────── */\n.auth-note {\n  background: rgba(240,249,255,0.8);\n  border: 1px solid rgba(147,197,253,0.4);\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.auth-note svg {\n  width: 15px;\n  height: 15px;\n  stroke: #3b82f6;\n  fill: none;\n  stroke-width: 2;\n  stroke-linecap: round;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.auth-note p {\n  font-size: 12.5px;\n  color: #1d4ed8;\n  line-height: 1.5;\n  font-weight: 400;\n  margin: 0;\n}\n\n/* ─── 2-col row ──────────────────────────────────────────── */\n.auth-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n@media (max-width: 480px) {\n  .auth-page {\n    padding: 24px 14px 80px;         /* extra bottom so last element isn't cut off */\n    align-items: flex-start;\n  }\n\n  .auth-card {\n    padding: 28px 18px 24px;\n    border-radius: 20px;\n    width: 100%;\n  }\n\n  .auth-title {\n    font-size: 22px;                 /* slightly smaller so it doesn't overflow */\n  }\n\n  .auth-social-row { grid-template-columns: repeat(3, 1fr); }\n  .auth-row { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
